'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _globals = require('../mixins/globals');

var _globals2 = _interopRequireDefault(_globals);

var _Datepicker = require('../components/Datepicker.vue');

var _Datepicker2 = _interopRequireDefault(_Datepicker);

var _UiAlert = require('../material/UiAlert.vue');

var _UiAlert2 = _interopRequireDefault(_UiAlert);

var _UiSelect = require('../material/UiSelect.vue');

var _UiSelect2 = _interopRequireDefault(_UiSelect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var format = [{ text: 'XLSX', value: 'xlsx' }, { text: 'XLS', value: 'xls' }, { text: 'CSV', value: 'csv' }];
var features = [{ text: 'Hospitalidad', value: 'servicio' }, { text: 'Rapidez', value: 'rapidez' }, { text: 'Sabor', value: 'sabor' }, { text: 'Ambiente', value: 'ambiente' }, { text: 'Variedad de Carta', value: 'variedad_de_carta' }];
exports.default = {
  name: 'ChartView',
  mixins: [_globals2.default],
  components: {
    DatePicker: _Datepicker2.default,
    UiAlert: _UiAlert2.default,
    UiSelect: _UiSelect2.default
  },
  data: function data() {
    return {
      showChart: false,
      locals: [],
      selectableLocals: [],
      error: {
        status: false,
        messages: ''
      },
      format: format,
      features: features,
      tempFeature: [],
      disabledBorn: {
        from: new Date()
      },
      born_start: new Date(),
      born_end: new Date(),
      tempLocal: [],
      dateStart: '',
      dateEnd: '',
      responseLocals: false,
      disabledChart: false,
      loadingChart: false,
      timeLimitDay: '',
      timeInitDay: '',
      tempFormat: null,
      flagAlert: false,
      arrayId: '&',
      options: []
    };
  },

  watch: {
    'error.status': function errorStatus(val, old) {
      var _this = this;

      if (val) {
        setTimeout(function () {
          _this.error.status = false;
        }, 1600);
      }
    },
    tempLocal: function tempLocal(val, old) {
      if (val !== null) {
        this.disabledChart = true;
      } else {
        this.disabledChart = false;
      }
    },
    tempFeature: function tempFeature(val, old) {
      this.showChart = false;
    }
  },
  created: function created() {
    var _d = new Date();
    var _m = _d.getMonth() + 1;
    var _month = _m <= 9 ? '0' + _m : '' + _m;
    this.dateEnd = _d.getFullYear() + '-' + _month + '-' + _d.getDate();
    this.dateStart = _d.getFullYear() + '-' + _month + '-' + _d.getDate();
    this.fetchLocal();
  },

  methods: {
    setSelectableLocals: function setSelectableLocals() {
      if (window.localStorage.getItem('restaurante') == 0) {
        this.selectableLocals = this.locals;
      } else {
        if (window.localStorage.getItem('local') == 0) {
          this.selectableLocals = this.locals.filter(function (val, key) {
            return val.r_id == window.localStorage.getItem('restaurante');
          });
        } else {
          this.selectableLocals = this.locals.filter(function (val, key) {
            return val.r_id == window.localStorage.getItem('restaurante') && val.value == window.localStorage.getItem('local');
          });
        }
      }
    },
    yymmdd: function yymmdd(_date) {
      var mm = _date.getMonth() + 1;
      var dd = _date.getDate();

      return [_date.getFullYear(), (mm > 9 ? '' : '0') + mm, (dd > 9 ? '' : '0') + dd].join('-');
    },
    ddmmyy: function ddmmyy(_date) {
      var mm = _date.getMonth() + 1;
      var dd = _date.getDate();

      return [(dd > 9 ? '' : '0') + dd, (mm > 9 ? '' : '0') + mm, _date.getFullYear()].join('-');
    },
    onSelectedDateStart: function onSelectedDateStart(_date) {
      this.dateStart = this.yymmdd(_date);
      this.born_start = _date;
    },
    onSelectedDateEnd: function onSelectedDateEnd(_date) {
      this.dateEnd = this.yymmdd(_date);
      this.born_end = _date;
    },
    generateCharts: function generateCharts() {
      this.disabledChart = true;
      this.options = [];
      this.showChart = false;
      for (var index in this.tempFeature) {
        this.options.push({
          chart: { zoomType: 'x' },
          title: { text: '', x: -20 },
          subtitle: { text: '', x: -20 },
          xAxis: { categories: [] },
          yAxis: {
            title: { text: 'Puntaje' },
            plotLines: [{ value: 0, width: 1, color: '#808080' }]
          },
          tooltip: { valueSuffix: '' },
          legend: { layout: 'vertical', align: 'right',
            verticalAlign: 'middle', borderWidth: 0 },
          series: []
        });
        this.initChart(index);
      }
      this.disabledChart = true;
      this.loadingChart = false;
      this.showChart = true;
    },
    initChart: function initChart(index) {
      this.arrayId = '&';
      this.flagAlert = false;
      this.options[index].title.text = 'Reporte de ' + this.tempFeature[index].text;
      this.options[index].subtitle.text = 'Reporte del ' + this.dateStart + ' al ' + this.dateEnd;
      var _arr1 = this.dateEnd.split('-');
      var _arr2 = this.dateStart.split('-');
      var date1 = new Date(_arr1);
      var date2 = new Date(_arr2);
      var timeDiff = Math.abs(date2.getTime() - date1.getTime());
      var diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
      if (diffDays > 31) {
        var _tempDate = this.addDays(_arr2, 31);
        this.timeLimitDay = this.yymmdd(_tempDate);
        this.flagAlert = true;
      } else {
        this.flagAlert = false;
        this.timeLimitDay = this.yymmdd(date1);
      }
      this.onSubmitChart(index);
    },
    addDays: function addDays(date, days) {
      var result = new Date(date);
      result.setDate(result.getDate() + days);
      return result;
    },
    onSubmitChart: function onSubmitChart(index) {
      var _this2 = this;

      this.showChart = false;
      var _url = '/admin/stats';
      this.disabledChart = true;
      this.loadingChart = true;
      var _tempLocals = [];
      var _tempNames = {};
      this.tempLocal.forEach(function (val) {
        _tempLocals.push(val.value);
        _this2.arrayId = _this2.arrayId + 'local_id[]=' + val.value + '&';
        _tempNames[val.text] = [];
      });
      var _obj = {
        before: this.dateEnd,
        after: this.dateStart,
        local_id: _tempLocals,
        feature: this.tempFeature[index].value
      };
      this.$http({
        url: _url,
        method: 'GET',
        params: _obj
      }).then(function (response) {
        var date1 = new Date(_this2.timeLimitDay);
        _this2.options[index].series = [];
        var _data = response.data;
        for (var _key in _data) {
          var _temp = _data[_key];
          var _intDate = parseInt(_key);
          if (_intDate <= date1.getTime()) {
            var _time = _this2.ddmmyy(new Date(_intDate * 1000));
            _this2.options[index].xAxis.categories.push(_time);
            for (var _key in _tempNames) {
              _tempNames[_key].push(0);
            }
            _temp.forEach(function (val) {
              var _x = _tempNames[val.local_name];
              _x[_x.length - 1] = parseFloat(val.avg);
            });
          } else {
            break;
          }
        }
        for (var _key in _tempNames) {
          _this2.options[index].series.push({
            name: _key,
            data: _tempNames[_key]
          });
        }
        _this2.$nextTick(function () {});
      }, function (response) {
        _this2.disabledChart = false;
        _this2.loadingChart = false;
      });
    },
    fetchLocal: function fetchLocal() {
      var _this3 = this;

      var _url = '/admin/local';
      this.$http({
        url: _url,
        method: 'GET'
      }).then(function (response) {
        var _data = response.data;
        _data.forEach(function (val) {
          _this3.locals.push({
            text: val.name,
            value: val.id + '',
            r_id: val.restaurante_id + ''
          });
        });
        _this3.setSelectableLocals();
        _this3.$nextTick(function () {
          _this3.responseLocals = true;
        });
      }, function (response) {
        if (response.status === 401 || response.status === 403) {
          window.localStorage.removeItem('restaurante');
          window.localStorage.removeItem('local');
          window.localStorage.removeItem('role');
          window.localStorage.removeItem('uid');
          _this3.$router.go({
            name: 'sign'
          });
        }
      });
    }
  }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"bgTransition\">\n  <template v-if=\"!responseLocals\">\n    <div class=\"preload-app\">\n      <ui-progress-linear :show=\"!responseLocals\" color=\"black\"></ui-progress-linear>\n    </div>\n  </template>\n  <template v-else=\"\">\n    <div class=\"header-section h_contact\">\n      <h2 v-if=\"titleShow\" transition=\"slideLeft\">Reporte por Caracteristica</h2>\n    </div>\n\n    <section class=\"section-chart\">\n      <template v-if=\"locals.length == 0\">\n        <ui-alert :dismissible=\"false\">No hay locales registrados.</ui-alert>\n      </template>\n      <template v-else=\"\">\n        <div class=\"width-filter col-4_filter\">\n          <div class=\"row\">\n            <div class=\"col-xs-6 col-sm-3\">\n              <date-picker label=\"Fecha de Inicio\" :value=\"born_start\" format=\"yyyy/MM/dd\" placeholder=\"DD/MM/YYYY\" input-class=\"ui-textbox-input\" language=\"es\" :disabled=\"disabledBorn\" @selected=\"onSelectedDateStart\"></date-picker>\n            </div>\n            <div class=\"col-xs-6 col-sm-3\">\n              <date-picker label=\"Fecha de Fin\" :value=\"born_end\" format=\"yyyy/MM/dd\" placeholder=\"DD/MM/YYYY\" input-class=\"ui-textbox-input\" language=\"es\" :disabled=\"disabledBorn\" @selected=\"onSelectedDateEnd\"></date-picker>\n            </div>\n            <div class=\"col-xs-6 col-sm-3\">\n              <ui-select name=\"level\" label=\"Local\" :options=\"selectableLocals\" multiple=\"\" placeholder=\"Seleccione un local\" :value.sync=\"tempLocal\"></ui-select>\n            </div>\n            <div class=\"col-xs-6 col-sm-3\">\n              <ui-select name=\"level\" label=\"Categoria\" :options=\"features\" multiple=\"\" placeholder=\"Seleccione una opción\" :value.sync=\"tempFeature\"></ui-select>\n            </div>\n          </div>\n          <div class=\"text-center\" style=\"color: #fff; margin-top: 8px;\">\n            <ui-button @click=\"generateCharts()\" text=\"Enviar\" color=\"lanacional-primario\" :loading=\"loadingChart\" :disabled=\"!disabledChart\"></ui-button>\n          </div>\n          <ui-alert :dismissible=\"false\" :show=\"flagAlert\" type=\"warning\">Solo se mostrarán los primeros 31 días a partir de la fecha de inicio indicada</ui-alert>\n        </div>\n        <br>\n        <div class=\"width-chart\" v-if=\"showChart\">\n          <div v-for=\"n in tempFeature.length\">\n            <div v-if=\"options[n]\">\n              <highcharts :options=\"options[n]\" ref=\"highcharts\"></highcharts>\n              <div class=\"text-left\" style=\"color: white\">\n                <ui-select name=\"level\" label=\"Formato\" :options=\"format\" placeholder=\"Seleccione una opción\" :value.sync=\"tempFormat\" default=\"xlsx\"></ui-select>\n                <a :href=\"'/admin/stats/export?before='+dateEnd+'&amp;after='+dateStart+''+arrayId+'feature='+tempFeature[n].value+'&amp;format='+tempFormat.value\" download=\"\">DESCARGAR REPORTE POR CARACTERISTICA</a>\n              </div>\n            </div>\n          </div>\n        </div>\n      </template>\n    </section>\n  </template>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-57dbc498", module.exports)
  } else {
    hotAPI.update("_v-57dbc498", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}